import type { ReactNode } from 'react';

import type { Address } from '../../../../graphql/generated/graphql';
import { formatAddress } from '../../../../utils';
import type { FormatterProps } from '../types/editor-config';
import { FormatterError } from './FormatterError';

const isAddress = (value: unknown): value is Address =>
  typeof value === 'object' &&
  value !== null &&
  ('streetName' in value ||
    'buildingNumber' in value ||
    'city' in value ||
    'postalCode' in value ||
    'countryCode' in value);

/**
 * Formats an Address (from the generated GraphQL types) as a compact single-line string:
 *   "Street Name 12, 11000 City, CC"
 * Parts that are missing are skipped, and redundant separators are collapsed.
 */
export function AddressFormatter({ value, errors }: FormatterProps): ReactNode {
  const text = isAddress(value) ? formatAddress(value) : String(value ?? '');

  return (
    <span className='inline-flex flex-col gap-2xs items-start'>
      <span>{text}</span>
      <FormatterError issues={errors} />
    </span>
  );
}
